export default __webpack_public_path__ + "static/media/3_roadmap.9279de0a.png";